// app-image-loader.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-loader',
  templateUrl: './app-image-loader.component.html',
  styleUrls: ['./app-image-loader.component.scss']
})
export class AppImageLoaderComponent {
  @Input() src!: string;
  @Input() alt = '';
  loaded = false;
}
